module.exports = __webpack_public_path__ + "media/error.3db85718.mp3";